/**
 * Registry of clinic → form component.
 *
 * Add new clinics by:
 *  1) Creating a component in ./<slug>.jsx
 *  2) Adding an entry here mapping the slug to a lazy import.
 *
 * Slug rule (see slugify in useClinicFormComponent):
 *  - lowercase, trim
 *  - non-alphanumeric → underscore
 *  - collapse multiple underscores
 *  - example: "Addenbrooks 2025" → "addenbrooks_2025"
 */

import { lazy } from "react";

export const FORM_REGISTRY = {
  // Example clinic mapping (file: ./addenbrooks_2025.jsx)
  addenbrooks_2025: lazy(() => import("./addenbrooks_2025")),

  // Fallback is handled separately; do not put "default" here.
};
